import { render, staticRenderFns } from "./passGroupList.vue?vue&type=template&id=6a6b03ea"
import script from "./passGroupList.vue?vue&type=script&lang=js"
export * from "./passGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports